module.exports = __webpack_public_path__ + "img/nav1.3a2a1e15.svg";